import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {JdDyForm} from './dy-form';
import {JdDyFormOptionItem} from './dy-form.interface';
import {JdDyFormComponent} from './dy-form.component';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

export const EXE_GROUP_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormGroupComponent),
  multi: true
};

@Component({
  selector: 'jd-form-group',
  providers: [EXE_GROUP_VALUE_ACCESSOR],
  template: `
    <jd-dy-form [dyForm]="_dyForm" [isInline]="true" [isGroup]="true"></jd-dy-form>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class FormGroupComponent implements OnInit, ControlValueAccessor, OnDestroy {
  OnChangeFn: Function;
  OnTouchedFn: Function;
  private _unsubscribe$ = new Subject();
  _dyForm: JdDyForm = new JdDyForm();

  _formGroupOptions: JdDyFormOptionItem[] = [];

  @Input() formControlName: string;

  @Input() jdDisabled = false;

  private _dyFormRef: JdDyFormComponent;

  @Input() set dyFormRef(value: JdDyFormComponent) {
    if (value && this._dyFormRef !== value) {
      this._dyFormRef = value;
      this._dyFormRef.dyForm.formGroupDyForm$.next({[this.formControlName]: this._dyForm});
      this._dyFormRef.formGroupDyForm[this.formControlName] = this._dyForm;
    }
  }

  get dyFormRef() {
    return this._dyFormRef;
  }

  @Input()
  set formGroupOptions(value: JdDyFormOptionItem[]) {
    this._formGroupOptions = value ? value : this._formGroupOptions;
    if (value) {
      this._dyForm.option = value;
      this._dyForm.valueChanges$.subscribe(value1 => {
        if (this.OnTouchedFn) {
          this.OnTouchedFn();
        }
        if (this.OnChangeFn) {
          this.OnChangeFn(value1);
        }
      });
    }
  }

  constructor() {
  }

  ngOnInit() {
    this._dyForm.OnNotSearchResult$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => {
        this.dyFormRef.OnNotSearchResult({isNeedLoading: value.isNeedLoading, value: value.value}, value.name);
      });

    this._dyForm.OpenChange$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(value => this._openChange(value.isOpen, value.key));
  }

  private _openChange(isOpen: boolean, name: string) {
    this._dyFormRef.dyForm.OpenChange$.next({
      isOpen: isOpen,
      key: name,
      isNeedLoading: isOpen && !this._dyForm.selectContentIsExit(name)
    });
  }

  registerOnChange(fn: any): void {
    this.OnChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.OnTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.jdDisabled = true;
  }

  writeValue(obj: any): void {
    this._dyForm.setValues(obj);
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
